<template lang="pug">
  .sidebar-layout(v-if="sidebarMode")
    .sidebar-layout__sidebar-wrapper
      sidebar(:items="sidebarOptions")
    .sidebar-layout__views-wrapper
      router-view
  router-view(v-else)
</template>

<script>
import Sidebar from '@/components/common/sidebar/Sidebar'

export default {
  name: 'Index',

  components: {
    Sidebar
  },

  data: (vm) => ({
    sidebar: [
      { id: 0, title: 'sidebar.farms', path: 'farms', icon: 'icon-farms' },
      { id: 1, title: 'sidebar.stocks', path: `stocks?company=${vm.$route.params.company_id}`, icon: 'icon-storage' }
    ]
  }),

  computed: {
    sidebarOptions () {
      return this.sidebar.map(item => ({
        ...item,
        path: this.$route.params.stock_id
          ? `../${item.path}`
          : item.path
      }))
    },

    sidebarMode () {
      return !this.$route.params.farm_id
    }
  }
}
</script>
